export const EXIT_DELAY_IN_MILLISECONDS = 500;
export const EXIT_DELAY_IN_SECONDS = EXIT_DELAY_IN_MILLISECONDS / 1000;

export const EXIT_DURATIONS = {
  max: EXIT_DELAY_IN_SECONDS / 1,
  half: EXIT_DELAY_IN_SECONDS / 2,
  third: EXIT_DELAY_IN_SECONDS / 3,
  quarter: EXIT_DELAY_IN_SECONDS / 4,
};
